export const companyGroupKey = ['companyGroup']

export const companyGroupDetailKey = (companyGroupId: number) => [
  ...companyGroupKey,
  companyGroupId,
]
